import { useEffect, useState } from "react";

const TorchLight = () => {
    const [pos, setPos] = useState({ x: 0, y: 0 });

    useEffect(() => {
        const move = (e) => {
            setPos({ x: e.clientX, y: e.clientY });
        };

        window.addEventListener("mousemove", move);
        return () => window.removeEventListener("mousemove", move);
    }, []);

    return (
        <div
            className="fixed inset-0 z-[900] pointer-events-none"
            style={{
                background: `radial-gradient(
                    circle 420px at ${pos.x}px ${pos.y}px,
                    rgba(255,255,255,0.06) 0%,
                    rgba(16,23,42,0.15) 35%,
                    rgba(16,23,42,0.35) 75%
                  )`,
                transition: "background 0.08s ease-out",
            }}
        />
    );
};

export default TorchLight;
